/**
 * HyperWrite: AI Autocomplete App — AI writing assistant / autocomplete
 *
 * Declares one web-accessible-resource entry matched to every origin with no dynamic URL,
 * listing content/inject.js and content/gDocsAnnotatedCanvas.js alongside image globs
 * (*.png, *.svg, *.gif, *.woff). The top-level icon128.png loads through probeImage with no
 * CORS grant, and the vendor-pathed content scripts corroborate at a fixed URL.
 *
 * Manifest verified against version 4.2.5.6.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'kljjoeapehcmaphfcjkmbhkinoaopdnd';

export const hyperwrite: ExtensionDefinition = {
  id: ID,
  name: 'HyperWrite: AI Autocomplete App',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 80_000,
  notes:
    'Named content scripts plus image globs exposed to every origin with no dynamic URL. ' +
    'The 128px icon loads without a CORS grant and is conclusive.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load icon128.png via <img> — the extension icon, matched by the *.png WAR glob ' +
        'on every origin and readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'icon128.png'),
    },
    {
      id: 'war-inject-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch content/inject.js — a named content script exposed to every origin at a ' +
        'fixed URL, corroborating the identification.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content/inject.js'),
    },
    {
      id: 'war-gdocs-annotated-canvas-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch content/gDocsAnnotatedCanvas.js — a distinctively-named Google Docs helper ' +
        'script, a third independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content/gDocsAnnotatedCanvas.js'),
    },
  ],
};
